import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { ArticleTypeDto } from 'src/app/shared/dto/article-type.dto';
import { BaseService } from 'src/app/shared/services/base.service';
import { SocketService } from 'src/app/shared/services/socket.service';
import { Messages } from 'src/app/shared/sockets/enums/messages';
import { Client, formatClientRoom, RoomNames } from 'src/app/shared/sockets/enums/rooms';
import { ArticleTypeResponseDto } from '../../shared/dto/pagination/article-type-response.dto';

@Injectable({
    providedIn: 'root',
})
export class ArticleTypeService extends BaseService {
    private articleTypesSubject = new BehaviorSubject<ArticleTypeDto[]>([]);
    public articleTypes$ = this.articleTypesSubject.asObservable();

    private readonly socketService = inject(SocketService);
    constructor(httpClient: HttpClient) {
        super(httpClient, 'article-type');
    }

    async setupWebSocket(): Promise<void> {
        try {
            this.articleTypesSubject.next((await this.findAll()).articleTypes);
            this.socketService.conectSocketRoom(formatClientRoom(Client.DEFAULT_CLIENT, RoomNames.ARTICLE_TYPES_ROOM));
            this.socketService.getNotifications(Messages.ARTICLE_TYPES_CHANGED).subscribe(async () => {
                const response = await this.findAll();
                this.articleTypesSubject.next(response.articleTypes);
            });
        } catch (e: any) {
            throw new Error(`Error al establecer conexión con el socket de Tipos de Artículo. Error: ${e.message}`);
        }
    }

    disconnectWebSocket(): void {
        this.socketService.disconnectSocketRoom(formatClientRoom(Client.DEFAULT_CLIENT, RoomNames.ARTICLE_TYPES_ROOM));
    }

    async findAll(): Promise<ArticleTypeResponseDto> {
        try {
            const request = this.httpClient.get<ArticleTypeResponseDto>(`${this.url}/findAll`);

            return (await lastValueFrom(request));
        } catch (e: any) {
            throw new Error(`No se ha encontrado ningún tipo de artículo. Error: ${e.message}`);
        }
    }
}
